import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import YodelCredentialsStore from "../../../../stores/credentials/shipping/yodel-credentials-store";

interface IProps {
    credentialsStore: YodelCredentialsStore,
    vGroup: IValidationGroup,
}

const YodelCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Yodel Client ID'
                key='client_id'
                note='Your Yodel Client ID'
            >
                <Input
                    value={credentialsStore.clientId}
                    onChange={credentialsStore.setClientId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Yodel Client Secret'
                key='client_secret'
                note='Your Yodel Client Secret'
            >
                <Input
                    value={credentialsStore.clientSecret}
                    onChange={credentialsStore.setClientSecret}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Yodel Account Number'
                key='account_number'
                note='Your Yodel Account Number'
            >
                <Input
                    value={credentialsStore.accountNumber}
                    onChange={credentialsStore.setAccountNumber}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Yodel Api Key'
                key='api_key'
                note='Your Yodel Api Key'
            >
                <Input
                    value={credentialsStore.apiKey}
                    onChange={credentialsStore.setApiKey}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default YodelCredentials;
